import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {takeUntilDestroy} from 'take-until-destroy';
import {PatientAccountService} from "../../../services/patient.account.service";
import {IPatientSearchResult} from "../common/common.types";
import {WebFormContainerComponent} from "../../../../common/components/web.form.container/web.form.container.component";
import {LogManager} from "../../../../common/log/log.manager";
import {LogCat} from "../../../../common/log/log.categories";
import {AppConfigurationService} from "../../../../common/app-config/app-configuration.service";

@Component({
  selector: 'app-patient-search',
  templateUrl: './patient.search.component.html',
  styleUrls: ['./patient.search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PatientSearchComponent implements OnInit, OnDestroy {
  @ViewChild('SearchPatientForm', {static: false}) searchPatientForm: WebFormContainerComponent;
  @Output() next = new EventEmitter();
  @Output() error = new EventEmitter();

  public patientSearchURL: string;
  public patientDataValidated = false;
  public showForm = true;

  constructor(private changeDetector: ChangeDetectorRef,
              private patientAccountSvc: PatientAccountService,
              private appConfigService: AppConfigurationService) {
  }

  ngOnInit() {
    this.patientSearchURL = this.appConfigService.Config.webForms.patientSearchURL;
  }

  ngOnDestroy() {

  }

  public continue() {
    this.searchPatientForm.getData();
  }

  public setPatient(patient: any) {
    this.searchPatientForm.setData(patient);
  }

  public reset() {
    this.showForm = false;
    this.changeDetector.markForCheck();
    setTimeout(() => {
      this.showForm = true;
      this.changeDetector.markForCheck();
    }, 10);
  }

  public searchPatient(patient: any) {
    this.patientAccountSvc.locatePatient(patient)
      .pipe(takeUntilDestroy(this))
      .subscribe(res => {
          const searchPatientResult: IPatientSearchResult = {
            patient,
            locatePatientRes: res
          };
          this.next.emit(searchPatientResult);
        },
        err => {
          LogManager.error(LogCat.Login.CreatePatientAccount, err);
          this.error.emit(patient);
        });
  }

  public dataValidated(valid: boolean) {
    this.patientDataValidated = valid;
    this.changeDetector.markForCheck();
  }
}
